module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAaCAMAAADyku75AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUxpcf///////////////////////////////////9noCcoAAAAJdFJOUwDIvWUcAfO2Gb9mBjsAAABZSURBVDjL7ZRLCkAxCANj7c/7X7jxbR/YHKCzcDUEBCOA4TajYJoPkN3iStvMEzyaAx4SDuNcHQV9UTHkHqVHMzdC5uLC5zzxiT9RPjP5cOUqyOWS66o+gAO95w898qL23gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company-landing-page--register-col-path@2x.png
// module id = 259
// module chunks = 0